import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {Button, Box, Stack, Tooltip} from "@mui/material";
import AdminInfoDialogue from "./Info/AdminInfoDialogue";
import {cancelQuery, getActiveQueries} from "./DatabaseAdminClient";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import {useDispatch} from "react-redux";
import CrudSnackbar from "../CommonComponents/CrudSnackbar";

export default function ActiveQueriesGrid() {
    const [rows, setRows] = useState([]);
    const [adminInfoOpen, setAdminInfoOpen] = useState(false);

    const dispatchData = useDispatch() ;


    const fetchRows = () => {
        return getActiveQueries()
            .then(res => {
                setRows(res.data);
            })
            .catch(err => {
                console.error(err);
                throw err;
            });
    };

    useEffect(() => {
        fetchRows();
    }, []);

    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const handleCancel = (pid) => {
        cancelQuery(pid)
            .then(() => {
                setRows(prevRows => prevRows.filter(row => row.pid !== pid));
                return delay(500);
            })
            .then(() => fetchRows())
            .then(() => {
                dispatchData(
                    changeCrudSnackbar({
                        crudOpen: true,
                        crudSeverity: "success",
                        crudMessage: "Job cancelled."
                    })
                );
            })
            .catch(err => {
                console.error(err);

                dispatchData(
                    changeCrudSnackbar({
                        crudOpen: true,
                        crudSeverity: "error",
                        crudMessage: "Cancel failed"
                    })
                );

                return fetchRows();
            });
    };

    const handleAdminInfo = () => {
        setAdminInfoOpen(true);
    };

    const handleCloseAdminInfo = () => {
        setAdminInfoOpen(false);
    };



    const columns = [
        { field: "pid", headerName: "PID", width: 100 },
        { field: "usename", headerName: "User", width: 150 },
        { field: "datname", headerName: "Database", width: 160 },
        { field: "state", headerName: "State", width: 120 },
        { field: "duration", headerName: "Duration", width: 160 },
        { field: "queryStart", headerName: "Query Start", width: 220 },
        { field: "query", headerName: "Query", width: 600 },
        {
            field: "actions",
            headerName: "Actions",
            width: 140,
            renderCell: (params) => (
                <Button
                    variant="outlined"
                    color="warning"
                    size="small"
                    onClick={() => handleCancel(params.row.pid)}
                >
                    Cancel
                </Button>
            )
        }
    ];

    return (
        <Box sx={{ height: 700, width: "100%" }}>
            <Stack direction="row" spacing={2}>

            <Box sx={{height: 70, pt: 1, pl: 3}}>
                <Tooltip enterDelay={1000} title={"Click for information."}>
                <h3  style={{cursor:'pointer'}}   onClick={() => handleAdminInfo()} >Active Jobs</h3>
                </Tooltip>
            </Box>

            <Button onClick={fetchRows} sx={{ mb: 1, pt: 2 }}>
                Refresh
            </Button>
            </Stack>
            <AdminInfoDialogue
                open={adminInfoOpen}
                onClose={handleCloseAdminInfo}
            />
            <DataGrid
                rows={rows}
                columns={columns}
                getRowId={(row) => row.pid}
                pageSize={25}
                rowsPerPageOptions={[25, 50, 100]}
                density="compact"
            />
            <CrudSnackbar/>
        </Box>
    );
}